import React, { useEffect, useState, useCallback } from "react";
import { East } from "@mui/icons-material";
import CustomModal from "../../Common/CustomModal";
import { CustomInput, CustomTextArea } from "../../Common/CustomInputs";
import axiosInstance from "../../../utils/config/config";
import { colors } from "../../../theme/theme";
import {
  MODAL_TITLE,
  SAVE_BTN_TEXT,
  CANCEL_BTN_TEXT,
  API_ENDPOINTS,
  ERROR_MESSAGES,
  LABELS,
  PLACEHOLDERS,
} from "./FinalEssayModal.constants";
import { ContentBox } from "./FinalEssayModal.styles";

const FinalEssayModal = ({
  open,
  handleClose,
  setLoading,
  setSuccess,
  setErrorState,
}) => {
  const [title, setTitle] = useState("");
  const [essay, setEssay] = useState("");

  const fetchEssay = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(API_ENDPOINTS.get);
      if (response.data) {
        setTitle(response.data.title ?? "");
        setEssay(response.data.content ?? "");
      }
    } catch (error) {
      console.error("Error fetching essay", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    if (open) fetchEssay();
  }, [open, fetchEssay]);

  const handleSave = async () => {
    setErrorState({ error: false, errorMsg: "" });

    if (!title?.trim() || !essay?.trim()) {
      setErrorState({ error: true, errorMsg: ERROR_MESSAGES.fillAll });
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post(API_ENDPOINTS.upsert, {
        title: title.trim(),
        content: essay.trim(),
      });

      if (response.data) {
        setSuccess(true);
        handleClose();
        fetchEssay();
      }
    } catch (error) {
      console.error("Error saving essay", error);
      setErrorState({
        error: true,
        errorMsg: error.message ?? "Error saving essay",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => handleClose();

  return (
    <CustomModal
      open={open}
      handleClose={handleClose}
      title={MODAL_TITLE}
      saveBtnText={SAVE_BTN_TEXT}
      cancelBtnText={CANCEL_BTN_TEXT}
      saveIcon={East}
      onSave={handleSave}
      onCancel={handleCancel}
    >
      <ContentBox>
        <CustomInput
          label={LABELS.title}
          value={title}
          setValue={setTitle}
          placeholder={PLACEHOLDERS.title}
          width="100%"
          noIcon
          smallBr
          bR="14px"
          color={colors.primary}
        />
        <CustomTextArea
          label={LABELS.essay}
          value={essay}
          setValue={setEssay}
          noIcon
          placeholder={PLACEHOLDERS.essay}
          width="100%"
          rows={7}
        />
      </ContentBox>
    </CustomModal>
  );
};

export default FinalEssayModal;
